.vendor-lead-step-pictures__container {
  display: flex;
  flex-flow: column nowrap;
  justify-content: flex-start;
  align-items: stretch;

  gap: 16px;

  padding: 24px 0 0;
}

.vendor-lead-step-pictures__container .vendor-lead-step-pictures__title {
  font-size: 18px;
  font-weight: 500;
  line-height: 28px;
  text-align: left;
}

.vendor-lead-step-pictures__container .vendor-lead-step-pictures__controls {
  display: flex;
  flex-flow: row nowrap;
  align-items: stretch;

  gap: 32px;
}

.vendor-lead-step-pictures__container .vendor-lead-step-pictures__items {
  display: flex;
  flex-flow: row nowrap;
  align-items: stretch;

  gap: 32px;
}

.vendor-lead-step-pictures__container .vendor-lead-step-pictures__add-photo__button {
  cursor: pointer;

  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: center;

  gap: 8px;

  padding: 14px;
  border-radius: 8px;
  border: 1px dashed #CCCFD8;

  &:hover {
    border-color: #0082F9;
  }
}

.vendor-lead-step-pictures__container  .vendor-lead-step-pictures__add-photo__text {
  color: #0082F9;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  text-align: center;
}

.vendor-lead-step-pictures__container .vendor-lead-step-pictures__info-icon {
  padding: 0 10px;
  border-radius: 50%;
  border: 1px solid #DADADA;

  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
}

.vendor-lead-step-pictures__container .vendor-lead-step-pictures__info-text {
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  text-align: left;

  & a {
    text-decoration: underline dashed;
  }
}

.vendor-lead-step-pictures__container .vendor-lead-step-pictures__images-preview {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  grid-auto-rows: 1fr;
  align-items: center;

  gap: 16px 24px;
}

.vendor-lead-step-pictures__container .vendor-lead-step-pictures__image-preview {
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: center;

  border: 1px solid var(--color-border);

  padding: 16px;
  max-width: 150px;
  width: 150px;
  max-height: 150px;
  height: 150px;

  & img {
    width: 100%;
    height: 100%;
    aspect-ratio: 1;
    object-fit: cover;
  }
}

.vendor-lead-step-pictures__container .vendor-lead-step-pictures__image-remove-icon {
  border: 0;
  padding: 0;
  min-width: 18px !important;
  min-height: 18px;
  width: 18px;
  height: 18px;
  line-height: 1;
}

.vendor-lead-step-pictures__container .vendor-lead-step-pictures__error {
  flex: 1;

  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: center;

  & .vendor-lead-step-pictures__error-message {
    position: relative;
  }
}

@media screen and (width <= 640px) {
  .vendor-lead-step-pictures__container .vendor-lead-step-pictures__controls {
    flex-flow: column nowrap;
    align-items: stretch;
  }

  .vendor-lead-step-pictures__container .vendor-lead-step-pictures__add-photo__button {
    flex: unset;
    height: 180px;
  }

  .vendor-lead-step-pictures__container .vendor-lead-step-pictures__images-preview {
    display: flex;
    flex-flow: column nowrap;
    align-items: stretch;

    gap: 16px;

    & .ant-badge {
      width: 100%;
    }
  }

  .vendor-lead-step-pictures__container .vendor-lead-step-pictures__image-preview {
    flex: 1;

    max-width: 100%;
    width: 100%;
    max-height: unset;
    height: unset;
  }
}
